import { FC } from 'react';
import { Icon } from 'src/models/Icon.interface';

const DiscountIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_878_3089)">
      <path
        d="M8.00663 1.34067C8.57463 1.34067 9.11863 1.56733 9.51796 1.96867L9.98329 2.434C10.133 2.58285 10.3355 2.66648 10.5466 2.66667H11.2133C11.7791 2.66667 12.3217 2.89143 12.7218 3.29151C13.1219 3.69158 13.3466 4.23421 13.3466 4.8V5.46667C13.3466 5.67733 13.4306 5.88 13.578 6.02867L14.0433 6.494C14.2425 6.69214 14.4007 6.92769 14.5086 7.18711C14.6166 7.44654 14.6722 7.72474 14.6723 8.00572C14.6724 8.28671 14.6171 8.56496 14.5093 8.82448C14.4016 9.084 14.2437 9.31969 14.0446 9.518L13.5793 9.98334C13.4304 10.1331 13.3468 10.3355 13.3466 10.5467V11.2133C13.3466 11.7791 13.1219 12.3218 12.7218 12.7218C12.3217 13.1219 11.7791 13.3467 11.2133 13.3467H10.5466C10.3362 13.3468 10.1342 13.43 9.98463 13.578L9.51929 14.0433C9.32116 14.2426 9.08561 14.4007 8.82618 14.5087C8.56676 14.6166 8.28856 14.6722 8.00757 14.6724C7.72658 14.6725 7.44834 14.6171 7.18882 14.5094C6.92929 14.4017 6.69361 14.2437 6.4953 14.0447L6.02996 13.5793C5.88024 13.4305 5.67775 13.3469 5.46663 13.3467H4.79996C4.23417 13.3467 3.69154 13.1219 3.29147 12.7218C2.89139 12.3218 2.66663 11.7791 2.66663 11.2133V10.5467C2.66645 10.3362 2.58333 10.1343 2.4353 9.98467L1.96996 9.51933C1.77072 9.3212 1.61259 9.08565 1.50464 8.82622C1.3967 8.5668 1.34107 8.2886 1.34094 8.00761C1.34082 7.72662 1.39621 7.44838 1.50392 7.18886C1.61164 6.92933 1.76957 6.69365 1.96863 6.49533L2.43396 6.03C2.58281 5.88028 2.66644 5.67779 2.66663 5.46667V4.8L2.66996 4.67867C2.70095 4.13474 2.93886 3.62327 3.33492 3.24916C3.73097 2.87505 4.25515 2.66664 4.79996 2.66667H5.46663C5.6771 2.66649 5.87902 2.58337 6.02863 2.43533L6.49396 1.97C6.69219 1.77059 6.92787 1.61234 7.18747 1.50433C7.44707 1.39633 7.72546 1.34071 8.00663 1.34067ZM9.66663 8.66667C9.40141 8.66667 9.14706 8.77203 8.95952 8.95956C8.77198 9.1471 8.66663 9.40145 8.66663 9.66667C8.66663 9.93188 8.77198 10.1862 8.95952 10.3738C9.14706 10.5613 9.40141 10.6667 9.66663 10.6667C9.93184 10.6667 10.1862 10.5613 10.3737 10.3738C10.5613 10.1862 10.6666 9.93188 10.6666 9.66667C10.6666 9.40145 10.5613 9.1471 10.3737 8.95956C10.1862 8.77203 9.93184 8.66667 9.66663 8.66667ZM10.4713 5.52867C10.3463 5.40369 10.1767 5.33348 9.99996 5.33348C9.82318 5.33348 9.65365 5.40369 9.52863 5.52867L5.52863 9.52867C5.40719 9.6544 5.33999 9.8228 5.34151 9.9976C5.34303 10.1724 5.41314 10.3396 5.53675 10.4632C5.66035 10.5868 5.82756 10.6569 6.00236 10.6585C6.17716 10.66 6.34556 10.5928 6.47129 10.4713L10.4713 6.47133C10.5963 6.34632 10.6665 6.17678 10.6665 6C10.6665 5.82323 10.5963 5.65369 10.4713 5.52867ZM6.33329 5.33333C6.06808 5.33333 5.81372 5.43869 5.62619 5.62623C5.43865 5.81376 5.33329 6.06812 5.33329 6.33333C5.33329 6.59855 5.43865 6.85291 5.62619 7.04044C5.81372 7.22798 6.06808 7.33333 6.33329 7.33333C6.59851 7.33333 6.85287 7.22798 7.0404 7.04044C7.22794 6.85291 7.33329 6.59855 7.33329 6.33333C7.33329 6.06812 7.22794 5.81376 7.0404 5.62623C6.85287 5.43869 6.59851 5.33333 6.33329 5.33333Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_878_3089">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ProductionMappingIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_877_859)">
      <path
        d="M1.33331 11.112C1.33331 10.6404 1.52064 10.1882 1.85408 9.85475C2.18752 9.52131 2.63976 9.33398 3.11131 9.33398H4.88865C5.3602 9.33398 5.81244 9.52131 6.14588 9.85475C6.47932 10.1882 6.66665 10.6404 6.66665 11.112V12.8893C6.66665 13.3609 6.47932 13.8131 6.14588 14.1466C5.81244 14.48 5.3602 14.6673 4.88865 14.6673H3.11131C2.87782 14.6673 2.64662 14.6213 2.4309 14.532C2.21518 14.4426 2.01918 14.3117 1.85408 14.1466C1.68897 13.9815 1.55801 13.7854 1.46866 13.5697C1.3793 13.354 1.33331 13.1228 1.33331 12.8893V11.112Z"
        fill={color}
      />
      <path
        d="M9.33331 11.112C9.33331 10.8785 9.3793 10.6473 9.46866 10.4316C9.55801 10.2159 9.68897 10.0199 9.85408 9.85475C10.0192 9.68965 10.2152 9.55868 10.4309 9.46933C10.6466 9.37997 10.8778 9.33398 11.1113 9.33398H12.8886C13.3602 9.33398 13.8124 9.52131 14.1459 9.85475C14.4793 10.1882 14.6666 10.6404 14.6666 11.112V12.8893C14.6666 13.1228 14.6207 13.354 14.5313 13.5697C14.442 13.7854 14.311 13.9815 14.1459 14.1466C13.9808 14.3117 13.7848 14.4426 13.5691 14.532C13.3533 14.6213 13.1221 14.6673 12.8886 14.6673H11.1113C10.8778 14.6673 10.6466 14.6213 10.4309 14.532C10.2152 14.4426 10.0192 14.3117 9.85408 14.1466C9.68897 13.9815 9.55801 13.7854 9.46866 13.5697C9.3793 13.354 9.33331 13.1228 9.33331 12.8893V11.112Z"
        fill={color}
      />
      <path
        d="M5.33331 3.11198C5.33331 2.64043 5.52064 2.18819 5.85408 1.85475C6.18752 1.52131 6.63976 1.33398 7.11131 1.33398H8.88865C9.3602 1.33398 9.81244 1.52131 10.1459 1.85475C10.4793 2.18819 10.6666 2.64043 10.6666 3.11198V4.88932C10.6666 5.36087 10.4793 5.81311 10.1459 6.14655C9.81244 6.47999 9.3602 6.66732 8.88865 6.66732H7.11131C6.63976 6.66732 6.18752 6.47999 5.85408 6.14655C5.52064 5.81311 5.33331 5.36087 5.33331 4.88932V3.11198Z"
        fill={color}
      />
      <path
        d="M7.99998 5.33398C7.82317 5.33398 7.6536 5.40422 7.52858 5.52925C7.40355 5.65427 7.33331 5.82384 7.33331 6.00065V7.33398H5.33331C4.23665 7.33398 3.33331 8.23732 3.33331 9.33398V10.0007C3.33331 10.1775 3.40355 10.347 3.52858 10.4721C3.6536 10.5971 3.82317 10.6673 3.99998 10.6673C4.17679 10.6673 4.34636 10.5971 4.47138 10.4721C4.59641 10.347 4.66665 10.1775 4.66665 10.0007V9.33398C4.66665 8.95798 4.95731 8.66732 5.33331 8.66732H10.6666C11.0426 8.66732 11.3333 8.95798 11.3333 9.33398V10.0007C11.3333 10.1775 11.4036 10.347 11.5286 10.4721C11.6536 10.5971 11.8232 10.6673 12 10.6673C12.1768 10.6673 12.3464 10.5971 12.4714 10.4721C12.5964 10.347 12.6666 10.1775 12.6666 10.0007V9.33398C12.6666 8.23732 11.7633 7.33398 10.6666 7.33398H8.66665V6.00065C8.66665 5.82384 8.59641 5.65427 8.47138 5.52925C8.34636 5.40422 8.17679 5.33398 7.99998 5.33398Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_877_859">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const GRNIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_756_946)">
      <path
        d="M3 21V8L12 4L21 8V21"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 13H17V21H7V15H13"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 21V12C13 11.7348 12.8946 11.4804 12.7071 11.2929C12.5196 11.1054 12.2652 11 12 11H10C9.73478 11 9.48043 11.1054 9.29289 11.2929C9.10536 11.4804 9 11.7348 9 12V15"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_756_946">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CustomerIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_756_1062)">
      <path
        d="M22.3166 16.0085C22.1742 15.8444 21.9674 15.75 21.75 15.75H20.25V14.25C20.25 13.4231 19.5771 12.75 18.75 12.75H15.75C14.9229 12.75 14.25 13.4231 14.25 14.25V15.75H12.75C12.5327 15.75 12.326 15.8445 12.1835 16.0085C12.0411 16.1729 11.9768 16.3909 12.0075 16.6062L12.7575 21.8562C12.8103 22.2253 13.1268 22.5 13.5 22.5H21C21.3732 22.5 21.6898 22.2253 21.7425 21.8562L22.4925 16.6062C22.5233 16.3909 22.459 16.173 22.3166 16.0085ZM15.75 14.25H18.75V15.75H15.75V14.25Z"
        fill={color}
      />
      <path d="M7.5 15H9V22.5H7.5V15Z" fill={color} />
      <path
        d="M12.5856 13.4062L11.1552 11.6184L10.0738 8.91428C9.72995 8.05515 8.90997 7.5 7.98462 7.5H3.75012C2.5094 7.5 1.50012 8.50927 1.50012 9.75V15C1.50012 15.8269 2.17287 16.5 3.00012 16.5H3.75012V22.5H5.25012V15H3.00012V9.75C3.00012 9.33615 3.33665 9 3.75012 9H7.98462C8.29295 9 8.56655 9.18532 8.68077 9.47167L9.91452 12.4688L11.4145 14.3438L12.5856 13.4062Z"
        fill={color}
      />
      <path
        d="M3 3.75C3 2.0958 4.3458 0.75 6 0.75C7.6542 0.75 9 2.0958 9 3.75C9 5.4042 7.6542 6.75 6 6.75C4.3458 6.75 3 5.4042 3 3.75ZM4.5 3.75C4.5 4.5771 5.17275 5.25 6 5.25C6.82725 5.25 7.5 4.5771 7.5 3.75C7.5 2.9229 6.82725 2.25 6 2.25C5.17275 2.25 4.5 2.9229 4.5 3.75Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_756_1062">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const OrderIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_756_1063)">
      <path
        d="M9 5H7C6.46957 5 5.96086 5.21071 5.58579 5.58579C5.21071 5.96086 5 6.46957 5 7V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V7C19 6.46957 18.7893 5.96086 18.4142 5.58579C18.0391 5.21071 17.5304 5 17 5H15"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 5C9 4.46957 9.21071 3.96086 9.58579 3.58579C9.96086 3.21071 10.4696 3 11 3H13C13.5304 3 14.0391 3.21071 14.4142 3.58579C14.7893 3.96086 15 4.46957 15 5C15 5.53043 14.7893 6.03914 14.4142 6.41421C14.0391 6.78929 13.5304 7 13 7H11C10.4696 7 9.96086 6.78929 9.58579 6.41421C9.21071 6.03914 9 5.53043 9 5Z"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 14H9.01"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 17H9.01"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 16L13 17L16 14"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_756_1063">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ProductionIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_756_976)">
      <path
        d="M4 21C5.147 16.98 5.983 12.973 6 9H12C12.017 12.973 12.853 16.98 14 21"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 13H17C17.025 15.612 17.894 18.296 19 21"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 5.00001C9.22717 4.68352 9.52797 4.42708 9.87642 4.25286C10.2249 4.07863 10.6105 3.99185 11 4.00001C11.3895 3.99185 11.7751 4.07863 12.1236 4.25286C12.472 4.42708 12.7728 4.68352 13 5.00001C13.2272 5.3165 13.528 5.57293 13.8764 5.74716C14.2249 5.92139 14.6105 6.00817 15 6.00001C15.3895 6.00817 15.7751 5.92139 16.1236 5.74716C16.472 5.57293 16.7728 5.3165 17 5.00001C17.2272 4.68352 17.528 4.42708 17.8764 4.25286C18.2249 4.07863 18.6105 3.99185 19 4.00001C19.3895 3.99185 19.7751 4.07863 20.1236 4.25286C20.472 4.42708 20.7728 4.68352 21 5.00001"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3 21H22"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_756_976">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LogsIcon: FC<Icon> = ({ color, size = '16px' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_756_993)">
      <path
        d="M4 12H4.01"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 6H4.01"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4 18H4.01"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 18H10"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 12H10"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 6H10"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 6H20"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 12H20"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 18H20"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_756_993">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export {
  GRNIcon,
  DiscountIcon,
  ProductionMappingIcon,
  CustomerIcon,
  OrderIcon,
  ProductionIcon,
  LogsIcon,
};
